var _g, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgResultGauge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("object", {
    width: "360px",
    height: "360px"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "360px",
    height: "360px",
    viewBox: "0 0 360 360",
    preserveAspectRatio: "xMinYMin",
    style: {
      position: "absolute"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(180,180)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "slice"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f5f3f1",
    d: "M-180,-2.2043642384652358e-14A180,180 0 0,1 180,0L160,0A160,160 0 0,0 -160,-1.9594348786357652e-14Z"
  }))))), /*#__PURE__*/React.createElement("svg", _extends({
    width: "360px",
    height: "360px",
    viewBox: "0 0 360 360",
    preserveAspectRatio: "xMinYMin",
    style: {
      position: "absolute"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(180,180)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "slice"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "gaugeId1632365707345OuterPath",
    fill: "#0000",
    d: "M-165,-2.0206672185931328e-14A165,165 0 0,1 165,0L160,0A160,160 0 0,0 -160,-1.9594348786357652e-14Z"
  })), /*#__PURE__*/React.createElement("text", null, /*#__PURE__*/React.createElement("textPath", {
    xlinkHref: "#gaugeId1632365707345OuterPath",
    startOffset: "10px",
    fontSize: 12,
    fontWeight: 700,
    style: {
      fill: "rgb(115, 115, 115)"
    }
  })), /*#__PURE__*/React.createElement("text", null, /*#__PURE__*/React.createElement("textPath", {
    xlinkHref: "#gaugeId1632365707345OuterPath",
    startOffset: "0px",
    fontSize: 12,
    fontWeight: 700,
    style: {
      fill: "rgb(115, 115, 115)"
    }
  }))))), /*#__PURE__*/React.createElement("svg", _extends({
    width: "360px",
    height: "360px",
    viewBox: "0 0 360 360",
    preserveAspectRatio: "xMinYMin",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(180,180)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "slice"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#dd4b39",
    d: "M-160,-1.9594348786357652e-14A160,160 0 0,1 -80.00000000000003,-138.56406460551017L-40.000000000000014,-69.28203230275508A80,80 0 0,0 -80,-9.797174393178826e-15Z"
  })), /*#__PURE__*/React.createElement("text", {
    x: -37.5,
    y: -120,
    className: "guage_label",
    dy: ".35em",
    transform: "rotate(-55)",
    style: {
      fill: "white"
    }
  }, "LOW")), /*#__PURE__*/React.createElement("g", {
    className: "slice"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff851b",
    d: "M-80.00000000000003,-138.56406460551017A160,160 0 0,1 79.99999999999999,-138.5640646055102L39.99999999999999,-69.2820323027551A80,80 0 0,0 -40.000000000000014,-69.28203230275508Z"
  })), /*#__PURE__*/React.createElement("text", {
    x: -10,
    y: -120,
    className: "guage_label",
    dy: ".35em",
    transform: "rotate(0)",
    style: {
      fill: "white"
    }
  }, "MED")), /*#__PURE__*/React.createElement("g", {
    className: "slice"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#00a65a",
    d: "M79.99999999999999,-138.5640646055102A160,160 0 0,1 160,-3.552713678800501e-14L80,-1.7763568394002505e-14A80,80 0 0,0 39.99999999999999,-69.2820323027551Z"
  })), /*#__PURE__*/React.createElement("text", {
    x: -17.5,
    y: -120,
    className: "guage_label",
    dy: ".35em",
    transform: "rotate(65)",
    style: {
      fill: "white"
    }
  }, "HIGH")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResultGauge);
export default __webpack_public_path__ + "static/media/ResultGauge.7651a01a45b3989997047a59b9648800.svg";
export { ForwardRef as ReactComponent };